import './index.css'
import cn from 'clsx'

import React from 'react'
import Icon, { ArrowUp } from 'components/ui/icon'
import Text from 'components/ui/text'
type Props = {
  active?: boolean
  onClick?: (...args: Array<any>) => any
  small?: boolean
}

/**
 * A drop zone placeholder component that provides visual feedback for file drag and drop operations
 * @param active - Whether the drop zone is currently active (user is dragging over it) - defaults to false
 * @param onClick - Optional callback function called when the placeholder is clicked
 * @param small - Whether to use small/compact styling - defaults to false
 * @returns A div element with drag and drop visual feedback and click handling
 */
const DropZonePlaceholder = ({
  active,
  onClick,
  small,
}: Props): React.ReactElement<'div'> => {
  if (active) {
    return (
      <div className="DropZonePlaceholder DropZonePlaceholder--Active hidden-phone ">
        <div className="DropZonePlaceholder__Container DropZonePlaceholder__Container--Active">
          <div className="DropZonePlaceholder__IconsContainer DropZonePlaceholder__IconsContainer--Active">
            <div className="DropZonePlaceholder__Circle">
              <ArrowUp width="18" height="18" />
            </div>
          </div>
          <Text type="small" color="#5f63ee">
            Drop files here
          </Text>
        </div>
      </div>
    )
  }

  return (
    <div
      className={cn('DropZonePlaceholder', 'hidden-phone', {
        'DropZonePlaceholder--small': small,
      })}
      onClick={onClick}
    >
      <div
        className={cn('DropZonePlaceholder__Container', {
          'DropZonePlaceholder__Container--small': small,
        })}
      >
        <Icon
          className="DropZonePlaceholder__Icon"
          type="upload-file"
          width="24"
          height="24"
        />
        <span>
          Drag files here, or <em>click to import</em>
        </span>
      </div>
    </div>
  )
}

export default DropZonePlaceholder
